import {
    ComponentFactoryResolver,
    Injector,
    StaticProvider,
    Type,
    ViewContainerRef,
} from '@angular/core';

import { DataComponent } from './component/data/data.component';
import { TextComponent } from './component/text/text.component';
import { CPopTemplate } from './model/c-pop-template.model';
import { CMPS_EC_DATA_ELEMENT, CMPS_EC_TEXT_ELEMENT } from './model/metadata';

export function inflate(
    parentInjector: Injector,
    factoryResolver: ComponentFactoryResolver,
    viewContainerRef: ViewContainerRef,
    tpl: CPopTemplate,
): void {
    viewContainerRef.clear();

    tpl.elements.forEach((e) => {
        try {
            const providers: StaticProvider[] = [];
            let compType: Type<any>;

            switch (e.type.toLowerCase().trim()) {
                case 'text':
                    providers.push({
                        provide: CMPS_EC_TEXT_ELEMENT,
                        useValue: e,
                    });
                    compType = TextComponent;
                    break;
                case 'data':
                    providers.push({
                        provide: CMPS_EC_DATA_ELEMENT,
                        useValue: e,
                    });
                    compType = DataComponent;
                    break;
            }

            const inj = Injector.create({
                providers,
                parent: parentInjector,
            });
            const comp = factoryResolver.resolveComponentFactory(compType);
            viewContainerRef.createComponent(comp, null, inj);
        } catch (err) {
            console.log(err);
        }
    });
}

export function deflate(viewContainerRef: ViewContainerRef): void {
    viewContainerRef.clear();
}
